module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/fader/fader.component.scss
// module id = ./src/app/shared/fader/fader.component.scss
// module chunks = main